import React from 'react';
import {
  FormControl,
  FormControlLabel,
} from '@mui/material';
import { Controller } from 'react-hook-form';
import { useTokens } from '@mcn-platform/models';
import { splitSeparator } from 'constants/general';
import { StandardFieldProps } from './FieldTypes';
import BulletPoints from './bulletItemsInput/BulletItems';
import HelperText from './HelperText';

const StandardStringArrayField = ({
  control,
  fieldName,
  field,
  readOnly,
}: StandardFieldProps) => {
  const tokens = useTokens();

  return (
    <Controller
      name={fieldName}
      control={control}
      render={({
        field: { onChange, value },
        fieldState: { isTouched, error },
      }) => {
        // Convert array to string format for BulletPoints component
        const convertArrayToString = (arr: any): string => {
          if (Array.isArray(arr)) {
            return arr.filter((item) => typeof item === 'string').join(splitSeparator);
          }
          if (typeof arr === 'string') {
            // Try to parse if it's a JSON string
            try {
              const parsed = JSON.parse(arr);
              if (Array.isArray(parsed)) {
                return parsed.filter((item) => typeof item === 'string').join(splitSeparator);
              }
            } catch {
              // Not JSON, treat as single string
              return arr || '';
            }
          }
          return '';
        };

        // Convert string back to array format
        const convertStringToArray = (str: string): string[] => {
          if (!str) return [];
          return str.split(splitSeparator).map((item) => item.trim()).filter((item) => !!item);
        };

        const handleValueChange = (newStringValue: string) => {
          onChange(convertStringToArray(newStringValue));
        };

        const label = field.tokenKey ? tokens.getToken(field.tokenKey) : field.label || 'No Label';
        const stringValue = convertArrayToString(value);

        return (
          <FormControl fullWidth>
            <FormControlLabel
              label={label}
              disabled={field.readOnly || readOnly}
              labelPlacement="top"
              control={(
                <BulletPoints
                  value={stringValue}
                  setValue={handleValueChange}
                  placeholder={field.placeholder || ''}
                  disabled={Boolean(field.readOnly || readOnly)}
                />
              )}
            />
            <HelperText
              name={fieldName}
              error={isTouched && error?.message}
              description={field.description}
            />
          </FormControl>
        );
      }}
    />
  );
};

StandardStringArrayField.defaultProps = {
  readOnly: false,
};

export default StandardStringArrayField;


